import React from 'react'
function FeaturesAndFunctions() {
return (
<div class="idocs-content">
   <div class="container">
      <div class="row">
         <div class="col-md-8">
            <section id="idocs_content">
               <h1>Features And Functions</h1>
               <hr />
               <ol class="mt-30">
                  <li><b>Multiple Payment Modes:</b> Choose from various payment modes like bank transfers and e-wallets.</li>
                  <li><b>API Integration:</b> Easy integration with business applications like CRM, ERPs, payroll and accounting software.</li>
                  <li><b>Bulk Payments:</b> Send payments to multiple beneficiaries in one go.</li>
                  <li><b>Customizable Payment Schedules:</b> Schedule payments as per your business needs.</li>
                  <li><b>Automated Reconciliation:</b> Automatically reconcile payments with business records.</li>
                  <li><b>Compliance and Security:</b> Payout solutions comply with regulatory requirements for data privacy and security.</li>
                  <li><b>Customer Support:</b> Get quick and efficient support for any payout-related issues.</li>
               </ol>
               <p>Overall, Playouts solutions offer a range of features to manage financial transactions effectively.</p>
            </section>
         </div>
         <div class="col-md-4">
         </div>
      </div>
   </div>
</div>
)
}
export default FeaturesAndFunctions